/**
 * @description Component-TradeFooterMobile
 */
import './index.less';

import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/Button';
import { setTradeFormSide } from '@/features/trade/actions';
import { useAppDispatch } from '@/hooks';
import { useChainId } from '@/hooks/web3/useChain';
import { Side } from '@synfutures/sdks-perp';

interface IPropTypes {
  className?: string;
  onFooterBtnClick?: (side: Side) => void;
}
const TradeFooterMobile: FC<IPropTypes> = function ({ onFooterBtnClick }) {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const chainId = useChainId();

  return (
    <div className="syn-trade-footer-mobile">
      <Button
        className="btn-long"
        onClick={() => {
          const tradeSide = Side.LONG;
          chainId &&
            dispatch(
              setTradeFormSide({
                chainId,
                tradeSide,
              }),
            );

          onFooterBtnClick?.(tradeSide);
        }}>
        {t('common.long')}
      </Button>
      <Button
        className="btn-short"
        onClick={() => {
          const tradeSide = Side.SHORT;
          chainId &&
            dispatch(
              setTradeFormSide({
                chainId,
                tradeSide,
              }),
            );

          onFooterBtnClick?.(tradeSide);
        }}>
        {t('common.short')}
      </Button>
    </div>
  );
};

export default TradeFooterMobile;
